module.exports = __webpack_public_path__ + "img/pc.4f23b798.svg";